import { render } from "./ElementsTabContainer.vue?vue&type=template&id=81489fe6&scoped=true"
import script from "./ElementsTabContainer.vue?vue&type=script&lang=js"
export * from "./ElementsTabContainer.vue?vue&type=script&lang=js"

import "./ElementsTabContainer.vue?vue&type=style&index=0&id=81489fe6&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81489fe6"]])

export default __exports__